import { Box, Button, Typography } from '@mui/material';
import { identityGenerateApiKeyStart } from '../../redux/identity/identitySlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useEffect } from 'react';

const GenerateAPIKey = ({ userId }: { userId: string }) => {
 const dispatch = useDispatch();
 const { success, apiKey } = useSelector((state: RootState) => state.identity);

 useEffect(() => {
  if (success?.identityGenerateKeyApi) {
   console.log('success', success);
  }
 }, [success]);

 return (
  <Box>
   {apiKey ? (
    <Typography>{apiKey}</Typography>
   ) : (
    <Button
     variant="outlined"
     color="primary"
     size="large"
     sx={{ width: '100%' }}
     onClick={() => {
      dispatch(identityGenerateApiKeyStart({ userId }));
     }}
    >
     Generate API Key
    </Button>
   )}
  </Box>
 );
};

export default GenerateAPIKey;

